import styled from 'styled-components';
import { Checkbox } from 'syf-component-library/ui/atoms';
import { colors, fontSizes, spacing } from 'syf-component-library/defaultTheme';
import { Inset } from 'syf-component-library/ui/spacing';
import { Body } from 'syf-component-library/ui/typography';
export const AgreementContainer = styled(Inset) `
  background-color: ${colors.lightestGrey};
  border-radius: 8px;
  border: ${props => props.hasError ? `2px solid ${colors.terracotta}` : 'none'};
`;
export const AgreementCheckbox = styled(Checkbox) `
  label {
    gap: ${spacing.medium}px;
  }
  label > div {
    margin: 0;
    padding: 0 ${spacing.medium}px 0 0;
    align-self: start;
    width: ${spacing.base}px;
    height: ${spacing.base}px;
  }

  label > div > div {
    border-width: 1px;
    border-color: #888a96; // color doesn't exist in component library
    background-color: ${colors.white};
    padding: 0;
    width: 20px; // sizing doesn't exist in component library
    height: 20px;
  }
`;
export const ErrorMessageText = styled(Inset) `
  font-size: ${fontSizes.small}px;
`;
export const ErrorWrapper = styled(Inset) `
  display: flex;
  align-items: center;
  color: ${colors.terracotta};
`;
export const TermsContainer = styled(Body) `
  font-size: 14px;
`;
